var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item[_vm.header.value])?_c('v-btn',{staticClass:"text-capitalize",attrs:{"text":"","href":_vm.dynamicFormLink.href,"light":"","color":"primary","disabled":_vm.header.permission ? !_vm.canPerformAction('VIEW_OFFER') : false}},[_vm._v(" "+_vm._s(_vm.header.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }